import "core-js/modules/web.dom.iterable";
import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { getOrgAssets } from '@data/setting';
import { getAppList as _getAppList } from '@data/user';
import env from '@/config/index';
import { logoOut } from '@data/user';
import validatePass from '@/components/validatePass';
import { getToken, getSessionToken } from '@/utils/auth';
export default {
  name: 'choose',
  data: function data() {
    return {
      sysList: [],
      backgroundImg: '',
      isShowDialog: false
    };
  },
  components: {
    validatePass: validatePass
  },
  watch: {
    isShowDialog: function isShowDialog(val) {
      var _this = this;

      if (!val) {
        this.$alert('密码修改成功！', '提示', {
          confirmButtonText: '重新登录',
          callback: function callback() {
            logoOut().then(function () {
              _this.setUserVo({});

              window.localStorage.removeItem('userInfo');
              localStorage.clear();

              _this.$router.push({
                path: '/login'
              });
            }).catch(function () {
              _this.setUserVo({});

              window.localStorage.removeItem('userInfo');
              localStorage.clear();

              _this.$router.push({
                path: '/login'
              });
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (userInfo && userInfo.isPrompt == 1) {
      this.isShowDialog = true;
    } else {
      this.getAppList();
    }
  },
  methods: _objectSpread({}, mapActions('user', {
    setUserVo: 'setUserVo'
  }), {
    getAppList: function getAppList() {
      var _this2 = this;

      _getAppList().then(function (res) {
        var remark = {
          bms: '管理教师、学生、班级等信息',
          mces: '记录工作学习中的每个精彩瞬间',
          emes: '发现能力特点 助力全面成长',
          sycp: '',
          edi: '发现能力特点 助力全面成长',
          ei: '多用户角色测评画像可视化呈现'
        };
        res.forEach(function (item) {
          item.showFlag = false;
          item.remark = remark[item.code];
        });
        _this2.sysList = res;

        if (_this2.sysList.length === 1) {
          _this2.setSimpleRole(_this2.sysList[0]);
        }

        _this2.tools.setLocalStorage('bmsAppLen', res.length);
      }).catch(function (err) {
        _this2.$message.warning(err.message || '请求错误！');
      });
    },
    setSimpleRole: function setSimpleRole(item) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      var token = getToken() || getSessionToken();

      if (item.code.toLocaleLowerCase() === 'bms') {
        this.$router.push({
          path: '/setting'
        });
      } else if (item.code.toLocaleLowerCase() === 'emes') {
        // 向测评传递token；来源origin
        if (this.$route.query.origin) {
          window.location.href = "".concat(env.emesUrl, "#/roleList/?type=").concat(userInfo.type, "&origin=").concat(this.$route.query.origin, "&token=").concat(token);
        } else {
          window.location.href = "".concat(env.emesUrl, "#/roleList/?type=").concat(userInfo.type, "&token=").concat(token);
        } // window.location.href = `http://localhost:8088/#/roleList/?type=${userInfo.type}&token=${token}`;

      } else if (item.code.toLocaleLowerCase() === 'mces') {
        window.location.href = "".concat(env.mcesUrl, "choseRole?type=").concat(userInfo.type, "&token=").concat(token);
      } else if (item.code.toLocaleLowerCase() === 'edi') {
        window.location.href = "".concat(env.ediUrl, "?token=").concat(token);
      } else if (item.code.toLocaleLowerCase() === 'ei') {
        window.location.href = "".concat(env.eiUrl, "/blank?token=").concat(token);
      } else {
        if (item && item.url) {
          window.location.href = "".concat(item.url, "?token=").concat(token); // window.location.href = `http://localhost:8081/#?token=${token}`;
        }
      }
    },
    checkIsNull: function checkIsNull(fieldVal) {
      return undefined === fieldVal || null === fieldVal || '' === fieldVal;
    },
    itemClass: function itemClass(appCode) {
      return 'readOnly-btn button' + appCode;
    },
    itemClassHover: function itemClassHover(appCode) {
      return 'click-btn button' + appCode;
    },
    itemCardClassHover: function itemCardClassHover(item, appCode) {
      if (item.showFlag) {
        return 'active card' + appCode;
      } else {
        return '';
      }
    },
    showHoverSys: function showHoverSys(index) {
      this.sysList[index].showFlag = true;
    },
    hideHoverSys: function hideHoverSys(index) {
      this.sysList[index].showFlag = false;
    }
  }),
  created: function created() {
    var _this3 = this;

    // 根据条件显示不同的背景图
    getOrgAssets({}).then(function (res) {
      _this3.backgroundImg = res.backgroundImg == 'guangzhou-background' ? 'url(' + require("../../assets/imgs/other/bg.png") + ')' : 'url(' + require("../../assets/imgs/user/home-choose.png") + ')';
    }).catch(function (error) {
      console.log(error);
    });
  }
};